<div class="error-page">
  <div class="error-container">
    <mat-icon [svgIcon]="'error-illustration'" class="error-svg"></mat-icon>
    <h1 class="error-title">
      @if (error()) {
        {{ error()?.message }}
      } @else {
        {{ 'labels.error.unknown' | translate }}
      }
    </h1>

    <button mat-flat-button color="primary" routerLink="/" class="home-button">
      {{ 'common.backToHome' | translate }}
    </button>
  </div>
</div>
